const listeners = new Map();

const eventEmitter = {
  on(event, handler) {
    if (!listeners.has(event)) {
      listeners.set(event, new Set());
    }
    listeners.get(event).add(handler);
  },
  off(event, handler) {
    const handlers = listeners.get(event);
    if (!handlers) return;
    handlers.delete(handler);
    if (handlers.size === 0) {
      listeners.delete(event);
    }
  },
  emit(event, ...args) {
    const handlers = listeners.get(event);
    if (!handlers) return;
    handlers.forEach((handler) => {
      handler(...args);
    });
  },
};

export default eventEmitter;
